import { Navigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '../../stores/authStore.js'
import { getCurrentUser } from '../../services/api.js'
import { hasModule } from '../../features/access/modules.js'

/**
 * Garde de route par module (défense en profondeur : le serveur bloque déjà les
 * API ; ceci évite d'afficher un écran vide en redirigeant vers l'accueil).
 * À placer dans une zone déjà protégée par ProtectedRoute.
 */
export default function ModuleRoute({ module, children }) {
  const authUser = useAuthStore((s) => s.user)
  const { data: me, isLoading } = useQuery({
    queryKey: ['currentUser'],
    queryFn: getCurrentUser,
    staleTime: 60000,
  })

  const user = me ?? authUser

  if (isLoading && !authUser) {
    return null
  }

  if (!hasModule(user, module)) {
    return <Navigate to="/dashboard" replace />
  }

  return children
}
